'use client';

import { useRouter } from 'next/navigation';
import { createClient } from '@/utils/supabase/client';
import { AccountWithRole } from '@/types/account';
import { useToast } from '@/hooks/use-toast';
import { User } from '@supabase/supabase-js';

export function useSwitchAccount() {
  const router = useRouter();
  const supabase = createClient();
  const { toast } = useToast();
  
  const switchAccount = async (ar: AccountWithRole, user?: User | null) => {
    if (ar?.account) {
        try {
            const { error: updateError } = await supabase
            .from('users')
            .update({
                config: {
                    default_account_id: ar.account.id,
                },
            }).eq('id', user?.id)
        
            if (updateError) throw updateError;
            router.refresh();
            toast({
                title: "Success!",
                description: `Account switched - ${ar.account.name}`,
            }) 
        } catch (e) {
            console.error("Error switching accounts", e)
            toast({
                title: "Error",
                variant: "destructive",
                description: "Could not Switch accounts!",
            }) 
        }
    }
  };

  return switchAccount;
}

export function useSignout() {
    const router = useRouter();
    const supabase = createClient();
  
    const signout = async () => {
        const { error } = await supabase.auth.signOut();
        
        if (error) {
            console.error('Error signing out:', error);
            return;
        }
        
        // Option 1: Force a complete router refresh
        // Force a complete page refresh or redirect to login/home
        router.push('/sign-in'); // or wherever you want users to go after logout
        router.refresh(); // Force a full refresh of the Next.js router state
        
        // Option 2: Alternative for guaranteed state reset
        // window.location.href = "/sign-in";
    };

    return signout;
}